import { Component, Input } from '@angular/core';

@Component({
    selector: 'tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: false
})
export class TabComponent {

  @Input('tabTitle')
  title: string;

  @Input() 
  active: boolean;

  @Input() 
  isInvalid: boolean;

  @Input() hide: boolean = false;
}
